// EventList.styles.js — 1:1 청구 반영 계약 목록 스타일 (2026-10-06 EventList.jsx 306줄에서 글자 그대로 분리)
export const S = {
  wrap: { display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0 },
  summary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    flexWrap: 'wrap',
  },
  summaryLeft: { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
  summaryTitle: { fontSize: 12, color: 'var(--text)', fontWeight: 950 },
  summaryText: { fontSize: 11, color: 'var(--text-muted)', fontWeight: 850 },
  list: { display: 'grid', gap: 5, minWidth: 0 },
  card: {
    border: '1px solid var(--border)',
    borderRadius: 8,
    padding: '7px 8px',
    background: 'var(--bg-card)',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  badges: {
    flex: '0 0 74px',
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    flexWrap: 'wrap',
    minWidth: 0,
  },
  main: { flex: '1 1 260px', minWidth: 0 },
  amount: (isCancel) => ({
    flex: '0 0 auto',
    color: isCancel ? '#dc2626' : '#2563eb',
    fontSize: 13,
    fontWeight: 950,
    whiteSpace: 'nowrap',
  }),
  title: {
    minWidth: 0,
    color: 'var(--text)',
    fontSize: 13,
    fontWeight: 950,
    lineHeight: 1.25,
    wordBreak: 'keep-all',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  meta: {
    marginTop: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    flexWrap: 'wrap',
    minWidth: 0,
    color: 'var(--text-muted)',
    fontSize: 11,
    lineHeight: 1.35,
  },
  itemText: {
    color: 'var(--text-sub)',
    fontWeight: 850,
    minWidth: 80,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  sourceText: {
    marginTop: 2,
    color: 'var(--text-muted)',
    fontSize: 10,
    fontWeight: 850,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  selectWrap: { display: 'flex', alignItems: 'center', gap: 5, marginLeft: 'auto' },
  selectLabel: { fontSize: 10, color: 'var(--text-muted)', fontWeight: 900 },
  select: {
    height: 26,
    minWidth: 72,
    border: '1px solid var(--border)',
    borderRadius: 7,
    padding: '0 6px',
    background: 'var(--bg-card)',
    color: 'var(--text)',
    fontSize: 11,
    fontWeight: 900,
    outline: 'none',
  },
  // 휴대폰 관리자 화면용(EventList touch) — 손가락으로 누르기 쉬운 크기
  selectTouch: { height: 40, minWidth: 96, fontSize: 14, borderRadius: 10, padding: '0 10px' },
  chip: (tone) => ({
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 999,
    padding: '2px 7px',
    background: tone === 'ok'
      ? 'rgba(22,163,74,0.12)'
      : tone === 'danger'
        ? 'rgba(220,38,38,0.10)'
        : tone === 'muted'
          ? 'rgba(100,116,139,0.12)'
          : tone === 'blue'
            ? 'rgba(37,99,235,0.10)'
            : 'rgba(245,158,11,0.14)',
    color: tone === 'ok' ? '#15803d' : tone === 'danger' ? '#dc2626' : tone === 'muted' ? 'var(--text-muted)' : tone === 'blue' ? '#2563eb' : '#b45309',
    fontSize: 10,
    fontWeight: 950,
    whiteSpace: 'nowrap',
  }),
  more: {
    alignSelf: 'flex-start',
    border: '1px solid var(--border)',
    borderRadius: 8,
    background: 'var(--bg-card)',
    color: '#2563eb',
    fontSize: 12,
    fontWeight: 950,
    cursor: 'pointer',
    padding: '5px 9px',
  },
  empty: { color: 'var(--text-muted)', fontSize: 12 },
};
